import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetTestCaseCommentList } from './testCaseComment.service'

const initialState = {
    commentListLoading: 'loaded',
    commentList: {},
}

// LIST TEST CASES
export const testCaseCommentList = createAsyncThunk(
    'testCaseCommentSlice/read',
    async (payload = {}) => {
        // const response = await getSprintsList(payload)
        const response = await apiGetTestCaseCommentList(payload)
        return response
    }
)

export const testCaseCommentSlice = createSlice({
    name: 'testCaseCommentSlice',
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(testCaseCommentList.pending, (state) => {
                state.commentListLoading = true
            })
            .addCase(testCaseCommentList.fulfilled, (state, action) => {
                state.commentListLoading = false
                state.commentList = action.payload.data
            })
    },
})

export default testCaseCommentSlice.reducer

export const testCaseCommentState = (state) => {
    const { testCaseCommentSlice } = state
    const { commentListLoading, commentList } = testCaseCommentSlice
    return {
        commentListLoading,
        commentList,
    }
}

export const {} = testCaseCommentSlice.actions
